import { Group } from '@mantine/core'
import { AppButton, AppModal, AppText } from '../../app/common/ui'

export interface AppealComingSoonModalProps {
  opened: boolean
  onClose: () => void
  summary?: string
}

/** Phase 6 will replace this with a real appeal submission flow. */
export default function AppealComingSoonModal ({
  opened,
  onClose,
  summary
}: AppealComingSoonModalProps) {
  return (
    <AppModal opened={opened} onClose={onClose} title="Appeal moderation action" centered>
      {summary
        ? (
        <AppText size="sm" color="dimmed" mb="sm">
          {summary}
        </AppText>
          )
        : null}
      <AppText size="sm" mb="md">
        Appeals are coming soon. You will be able to contest warnings, removals, and suspensions from this screen.
        Until then, contact support if you believe a decision was made in error.
      </AppText>
      <Group position="right">
        <AppButton onClick={onClose}>Close</AppButton>
      </Group>
    </AppModal>
  )
}
